type VerdictBadgeProps = {
  verdict: string;
  type?: string;
  size?: "sm" | "md";
};

const styles: Record<string, string> = {
  fake: "bg-primary-500 text-background-50",
  real: "bg-accent-500 text-foreground-950",
  unsure: "bg-secondary-200 text-secondary-900",
};

export default function VerdictBadge({ verdict, type = "unsure", size = "sm" }: VerdictBadgeProps) {
  const cls = styles[type] ?? styles.unsure;
  const sizeCls = size === "md" ? "text-xs px-3 py-1.5" : "text-[11px] px-2.5 py-1";
  return (
    <span className={`font-label rounded-full whitespace-nowrap ${cls} ${sizeCls}`}>
      {verdict}
    </span>
  );
}